import React from "react";

function Office() {
  return (
    <div>
      <h1>This is office page</h1>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut expedita
        modi nesciunt nobis recusandae laboriosam omnis amet tempora repudiandae
        ullam vitae corrupti dignissimos praesentium deserunt, cupiditate
        nostrum velit corporis eligendi!
      </p>
    </div>
  );
}

export default Office;
